import Vue from 'vue'
import CommunityEngineVue from '@bettertogether/community-engine-vue'

Vue.use(CommunityEngineVue)
